import React from "react";
import { Spin } from "antd";
import { useGlobal } from "../contexts/GlobalContext";
import { isAdminRole, isSuperAdminRole } from "../utils/roles";
import PageState from "../components/common/PageState";

// 角色路由守卫：后端接口本就强制 admin/superadmin，这里做前端纵深防御——
// 非管理员手输 URL 不再进入页面空壳，而是看到明确的无权限提示。
// - 用户信息加载中 → 转圈
// - 角色不足 → forbidden 提示（不重定向，保留 URL 便于切换账号后刷新）
// - 命中 → 渲染子页面
const RoleGuard: React.FC<{
  require?: "admin" | "superadmin";
  children: React.ReactNode;
}> = ({ require = "admin", children }) => {
  const { user } = useGlobal();

  if (!user) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 80 }}>
        <Spin />
      </div>
    );
  }
  const role = user?.apiInfo?.role;
  const allowed = require === "superadmin" ? isSuperAdminRole(role) : isAdminRole(role);
  if (!allowed) {
    return (
      <PageState
        kind="forbidden"
        title="需要管理员权限"
        description={require === "superadmin" ? "该页面仅超级管理员可访问。" : "该页面仅管理员可访问。"}
      />
    );
  }
  return <>{children}</>;
};

export default RoleGuard;
